"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupRoleBranchControllerImpl = void 0;
const groupRoleBranch_1 = require("../requests/groupRoleBranch");
class GroupRoleBranchControllerImpl {
    subject;
    constructor(subject) {
        this.subject = subject;
    }
    parseGroupRoleBranches(response) {
        return Object.entries(response.RoleToBranches).map(([roleId, branchIds]) => ({
            id: Number(roleId),
            branchIds: branchIds,
        }));
    }
    async getAllGroupRoleBranches(branchId, userId) {
        const res = await (0, groupRoleBranch_1.getAllGroupRoleBranchesRequest)(branchId, userId);
        const groupRoleBranches = this.parseGroupRoleBranches(res);
        groupRoleBranches.forEach((groupRoleBranch) => {
            this.subject.set(groupRoleBranch);
        });
    }
    async getGroupRoleBranches(branchId, userId, params) {
        const res = await (0, groupRoleBranch_1.getGroupRoleBranchesRequest)(branchId, userId, params);
        const groupRoleBranches = this.parseGroupRoleBranches(res);
        groupRoleBranches.forEach((groupRoleBranch) => {
            this.subject.set(groupRoleBranch);
        });
    }
    async patchGroupRoleBranches(branchId, userId, body) {
        await (0, groupRoleBranch_1.patchGroupRoleBranchesRequest)(branchId, userId, body);
        this.subject.set({ id: body.roleId, branchIds: body.selectedBranchIds });
    }
    async setGroupRoleBranch(groupRoleBranch) {
        this.subject.set(groupRoleBranch);
    }
}
exports.GroupRoleBranchControllerImpl = GroupRoleBranchControllerImpl;
